// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-18db4fa0] {\n  height: 8rem;\n  width: 100%;\n  background-color: #E8E8E7;\n}\n", ""]);
// Exports
module.exports = exports;
